import type { tMenu } from 'src/shared/frontendTypes/navigation'
import { getSearchImageProps } from 'src/layout/Header/searchImages'

export const getNavigationImageProps = (src: string) => ({
  ...getSearchImageProps(src),
  sizes: '(max-width: 420px) calc((100vw - 32px) * .78), 303px',
})

const warmed = new Set<string>()
const scheduled = new Set<string>()
export const warmNavigationImages = (sources: string[]) => {
  if (typeof window === 'undefined') return
  for (const src of sources.slice(0, 8)) {
    if (warmed.has(src)) continue
    warmed.add(src)
    const props = getNavigationImageProps(src)
    const image = new Image()
    image.decoding = 'async'
    image.setAttribute('fetchpriority', 'low')
    image.onerror = () => warmed.delete(src)
    image.sizes = props.sizes
    if (props.srcSet) image.srcset = props.srcSet
    image.src = props.src || src
  }
}

/** Warm only the small responsive category candidates after the page has loaded.
 * No extra network work for desktop, Save-Data or slow mobile connections. */
export const scheduleNavigationImageWarmup = (paths: tMenu) => {
  if (typeof window === 'undefined' || !window.matchMedia('(max-width: 899px)').matches) return
  const connection = (navigator as Navigator & { connection?: { saveData?: boolean; effectiveType?: string } }).connection
  if (connection?.saveData || ['slow-2g', '2g'].includes(connection?.effectiveType || '')) return
  const sources = paths.slice(0, 8).flatMap(entry => entry.imageSrc ? [entry.imageSrc] : [])
  const key = sources.join('\n')
  if (!key || scheduled.has(key)) return
  scheduled.add(key)
  const warm = () => {
    const run = () => warmNavigationImages(sources)
    if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 2000 })
    else setTimeout(run, 500)
  }
  if (document.readyState === 'complete') warm()
  else window.addEventListener('load', warm, { once: true })
}
